import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { API } from "../../config/api";
import {Col,Form,Button} from 'reactstrap'
import Logo_Dashboard from '../../assets/ysb/logo_alsum.png'
import Logo_Dashboard2 from '../../assets/ysb/simag.png'
import { Link } from 'react-router-dom'
import Card from 'react-bootstrap/Card';
import {FaUserAlt, FaLock} from 'react-icons/fa'
import Caro1 from '../../assets/ysb/background-biru-ornamen.jpg'
import "./Login.css"
import ToastError from "../NotificationToast/ToastError"
import ToastSuccess from "../NotificationToast/ToastSuccess"
import { ScaleLoader } from "react-spinners";

export default function Login() {
  let navigate = useNavigate();
  document.title = "Login";
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const { email, password } = form;

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = useMutation(async (e) => {
    try {
      e.preventDefault();
      setLoading(true)

      // Configuration
      const config = {
        headers: { "Content-type": "application/json" }
      };
      // Data body
      const body = JSON.stringify(form);
      const now = Date.now();
      const expiryTime = now + 86400000;

      // Insert data for login process
      const response = await API.post("/api/auth/login", body, config);
      localStorage.setItem('token', response.data.data.token);
      localStorage.setItem("token_expiry", expiryTime);
      localStorage.setItem('name-admin', response.data.data.user.username)
      localStorage.setItem('photo-admin', response.data.data.user.photo_profile)
      localStorage.setItem('id_admin', JSON.stringify(response.data.data.user.id));
      localStorage.setItem('email_admin', JSON.stringify(response.data.data.user.email));
      localStorage.setItem('level', response.data.data.user.level);
      localStorage.setItem('ysb_branch_id', response.data.data.user.ysb_branch_id ?? "");
      localStorage.setItem('ysb_school_id', response.data.data.user.ysb_school_id ?? "");
      localStorage.setItem('id_teacher', response.data.data.user.id_teacher ?? "");
      localStorage.setItem('id_role', response.data.data.user.id_role ?? "");
      localStorage.setItem('ysb_role_name', response.data.data.user.ysb_role_name ?? "");
      localStorage.setItem('teacher_data', response.data.data.user.teacher_data !== null ? JSON.stringify(response.data.data.user.teacher_data) : "");
      localStorage.setItem('menus', JSON.stringify(response.data.data.user.modules)? JSON.stringify(response.data.data.user.modules) : "" )
      localStorage.setItem('role_permission', JSON.stringify(response.data.data.user.role_permission)? JSON.stringify(response.data.data.user.role_permission) : "" )
      localStorage.setItem('roles', JSON.stringify(response.data.data.user.roles).length === 0 ? "" : JSON.stringify(response.data.data.user.roles))

      // Checking process tes
      if (response?.status === 200) {
        setLoading(false)
        ToastSuccess.fire({
          icon: 'success',
          title: response.data.message,
          background: '#1d3557', 
          color: '#ffffff'
        })
        navigate("/dashboard");
      }
    } catch (error) {
      setLoading(false)
      ToastError.fire({
        icon: 'error',
        title: `${error.response.data.message}`,
      })
    }
  });

  return (
        <div className='auth-wrapper auth-cover' >
              <Col xl='12' sm='12'>  
                <Card.Img src={Caro1} alt="Card image" style={{ width: "100%", height: "100vh", }} />
                <Card.ImgOverlay style={{ marginTop: "0px", marginLeft: "0px", display:"flex", 
                  justifyContent:"center", alignItems:"center"}}>
                    <div style={{backgroundColor:"transparent", borderRadius:"5px" , boxShadow:"1px 1px 10pxrgb(249, 249, 249)"}}>
                    <div style={{display:"flex", justifyContent:"center"}}>
                      <div style={{backgroundColor:"", borderTopLeftRadius:"3px",borderTopRightRadius:"3px", 
                        width:"100%", display:"flex", justifyContent:"center",padding:"0px 0px"}}>
                        <img  style={{borderRadius:"10px", width:"180px", height:"160px"}} src={Logo_Dashboard} alt='Login Cover' />
                      </div>
                    </div>

                    <div style={{display:"flex", justifyContent:"center", backgroundColor:"transparent"}}>
                      <div style={{backgroundColor:"", width:"100%", 
                        display:"flex", justifyContent:"center", fontFamily:"Poppins", fontWeight:"bold", color:"white", 
                        padding:"5px 0px"}}>
                          <img style={{borderRadius:"10px", width:"280px", height:"100px"}} src={Logo_Dashboard2} alt='Login Cover' />
                      </div>
                    </div>

                      <Form className='auth-login-form' onSubmit={(e) => handleSubmit.mutate(e)} style={{display:"flex", justifyContent:"center", 
                        marginTop:"0px", padding:"10px 20px", backgroundColor:"white", borderRadius:"5px"}}>
                        <div>
                          <div className="" style={{ display: "flex", alignItems: "center", backgroundColor: "white", 
                            border: "1px solid #3E97E5", padding: "5px", borderRadius: "5px" }}>
                          <div style={{ padding: "0 10px", color: "#B9B9B9" }}>
                            <FaUserAlt />
                          </div>
                            <input 
                              value={email} 
                              name="email" 
                              onChange={handleChange} 
                              autoFocus 
                              type='text' 
                              placeholder='NIK YSB/Email' 
                              style={{ backgroundColor: "transparent", border: "none", outline: "none", color: "#626262", 
                                padding: "5px 10px", flex: 1 }} 
                            />
                
                          </div>
                          <div className="mt-3" style={{ display: "flex", alignItems: "center", backgroundColor: "white", 
                            border: "1px solid #3E97E5", padding: "5px", borderRadius: "5px" }}>
                          <div style={{ padding: "0 10px", color: "#B9B9B9" }}>
                            <FaLock />
                          </div>
                            <input 
                              value={password} 
                              name="password" 
                              onChange={handleChange} 
                               
                              type='password' 
                              placeholder='Password' 
                              style={{ backgroundColor: "transparent", border: "none", outline: "none", color: "#626262", 
                                padding: "5px 10px", flex: 1 }} 
                              // className="custom-input"
                            />
                          </div>
                          <div style={{padding:"0px 0px"}}>
                            {loading? 
                            <Button className="mt-4 w-100" type='submit' color="warning" style={{padding:"10px 0px", 
                            fontSize:"15px", borderRadius:"5px", backgroundColor:"", color:"white"}}>
                              <ScaleLoader color={'white'} height={12} width={5} />
                            </Button>
                            :
                            <Button className="mt-4 w-100" type='submit' color="primary" style={{padding:"10px 0px", 
                            fontSize:"15px", borderRadius:"5px", backgroundColor:"", color:"white"}}>
                              Sign in
                            </Button>
                            }

                            <div className="mt-3" type='submit' color='' style={{display:"flex", justifyContent:"center",
                              padding:"10px 0px", fontSize:"12px", borderRadius:"5px", color:"##B9B9B9", border:"none"  }}>
                              Lupa Password?
                              <Link to="/register-matel" style={{ marginLeft: "2px", textDecoration: "none" }}>
                                <span className="">Reset</span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </Card.ImgOverlay>
              </Col>
        </div>
  );
}
